jQuery( document ).ready( function ( $ ) {

	//Actually change the visible slide
	var changeSlide = function ( $container, id, $slide ) {
		if ( $container.hasClass( 'mobile' ) ) {
			$slide.show();
			$slide.find( '.question' ).show();
			$slide.find( '.answer' ).hide();
		} else {
			$slide.css( 'display', 'flex' );
		}
		$container.find( '.slide:not([data-id="' + id + '"])' ).hide();
		$container.children( 'ul' ).removeClass( 'showing-answer' ).find( '[data-id="' + ( id ) + '"]' ).addClass( 'active' ).parent().siblings().children().removeClass( 'active' );
	};

	var initChallengeBrowser = function () {
		var $this = $( this );
		if ( $this.css( 'zIndex' ) == 1 ) {
			return initChallengeBrowserForMobile( $this );
		}
		initChallengeBrowserForDesktop( $this );
	};

	//Initialize this component
	var initChallengeBrowserForDesktop = function ( $this ) {
		var maxHeight = 0,
			$slides = $this.find( '.slide' ),
			slideCount = $slides.length,
			slideNav = '<ul>',
			leftEdge = 0,
			navGap = 0,
			$slideNav, hidden = true;

		if ( $this.css( 'display' ) != 'none' ) hidden = false;
		$this.show();
		$this.data( 'slides', slideCount );

		//Go through each slide
		$slides.each( function ( i ) {
			let slideHeight, $slide = $( this ),
				$question = $slide.find( '.question' ),
				$nav, $questionContent = $question.children( 'div' );

			if ( i == 0 ) {
				leftEdge = ( ( $( window ).width() - $( '#masthead' ).width() ) / 2 ) - $questionContent.width() - parseFloat( $questionContent.css( 'paddingLeft' ) ) - parseFloat( $questionContent.css( 'paddingRight' ) );
			}

			//add nav links
			$questionContent.css( 'paddingBottom', '5rem' ).append( '<nav></nav>' );
			$nav = $question.find( 'nav' );
			switch ( i ) {
			case 0:
				$nav.append( '<a class="c-button c-button__link next"><span>Next Question</span></a>' );
				break;
			case slideCount - 1:
				$nav.append( '<a class="c-button c-button__back previous"><span>Previous Question</span></a>' );
				break;
			default:
				$nav.append( '<ul><li><a class="c-button c-button__back previous"><span>Previous Question</span></a></li><li><a class="c-button c-button__link next"><span>Next Question</span></a></li>' );
				$nav.addClass( 'both' );
			}
			//Pad question divs to make room for left nav
			$question.addClass( 'has-nav' );

			//Factor height
			slideHeight = $slide.height();
			if ( slideHeight > maxHeight ) maxHeight = slideHeight;
		} );

		//Set all slides' heights
		$slides.find( '.question > div' ).css( 'height', maxHeight + 'px' );
		$this.css( 'height', maxHeight + 'px' );

		//Stack slides
		$this.addClass( 'browser' );

		//Add nav
		for ( let i = 0; i < slideCount; i++ ) {
			slideNav += '<li><a' + ( i == 0 ? ' class="active"' : '' ) + ' href="#" data-id="' + ( i + 1 ) + '">&nbsp;</a></li>';
		}
		slideNav += '</ul>';
		$this.prepend( slideNav );
		$slideNav = $this.children( 'ul' );
		$slideNav.css( {
			left: leftEdge + 'px'
		} );
		navGap = $slideNav.height();
		navGap = navGap - ( slideCount * 8 ); //Nav items are 8px tall
		navGap = Math.floor( navGap / ( slideCount - 1 ) ) + 'px';
		$slideNav.find( 'li' ).each( function ( i ) {
			if ( i == 0 ) return;
		} );

		//Add listeners
		$slideNav.find( 'a[data-id]' ).on( 'click', jumpSlide );
		$this.find( '.previous' ).on( 'click', previousSlide );
		$this.find( '.next' ).on( 'click', nextSlide );

		if ( $slides.length > 0 ) {
			$( $slides[ 0 ] ).css( 'display', 'flex' );
		}
		if ( hidden ) $this.hide();
	};

	//Initialize this component
	var initChallengeBrowserForMobile = function ( $this ) {
		var maxHeight = 0,
			$slides = $this.find( '.slide' ),
			slideCount = $slides.length,
			slideNav = '<ul>',
			leftEdge = 0,
			navGap = 0,
			$slideNav, hidden = true;

		if ( $this.css( 'display' ) != 'none' ) hidden = false;
		$this.show();
		$this.data( 'slides', slideCount );

		//Go through each slide
		$slides.each( function ( i ) {
			let slideHeight, $slide = $( this ),
				$question = $slide.find( '.question' ),
				$nav, $answer = $slide.find( '.answer' ),
				$answerContent = $answer.children( 'div' );

			//add nav links
			$answerContent.css( 'paddingBottom', '5rem' ).append( '<nav></nav>' );
			$nav = $answer.find( 'nav' );
			switch ( i ) {
			case 0:
				$nav.append( '<a class="next">Next Question</a>' );
				break;
			case slideCount - 1:
				$nav.append( '<a class="previous">Previous Question</a>' );
				break;
			default:
				$nav.append( '<ul><li><a class="previous">Previous Question</a></li><li><a class="next">Next Question</a></li>' );
				$nav.addClass( 'both' );
			}

			$question.children( 'div' ).append( '<p class="show-answer"><a href="#">We Answered</a></p>' );

			//Factor height
			slideHeight = $question.height();
			if ( slideHeight > maxHeight ) maxHeight = slideHeight;
			slideHeight = $answer.height();
			if ( slideHeight > maxHeight ) maxHeight = slideHeight;
		} );

		//Set all slides' heights
		$slides.find( '> div > div' ).css( 'height', maxHeight + 'px' );
		$this.css( 'height', maxHeight + 'px' );

		//Stack slides
		$this.addClass( 'browser' );
		$this.addClass( 'mobile' );

		//Add nav
		for ( let i = 0; i < slideCount; i++ ) {
			slideNav += '<li><a' + ( i == 0 ? ' class="active"' : '' ) + ' href="#" data-id="' + ( i + 1 ) + '">&nbsp;</a></li>';
		}
		slideNav += '</ul>';
		$this.prepend( slideNav );
		$slideNav = $this.children( 'ul' );
		$slideNav.css( {
			left: '1.5rem'
		} );
		navGap = $slideNav.height();
		navGap = navGap - ( slideCount * 8 ); //Nav items are 8px tall
		navGap = Math.floor( navGap / ( slideCount - 1 ) ) + 'px';
		$slideNav.find( 'li' ).each( function ( i ) {
			if ( i == 0 ) return;
		} );

		//Add listeners
		$slideNav.find( 'a[data-id]' ).on( 'click', jumpSlide );
		$this.find( '.previous' ).on( 'click', previousSlide );
		$this.find( '.next' ).on( 'click', nextSlide );
		$this.find( '.show-answer a' ).on( 'click', showAnswer );

		if ( $slides.length > 0 ) {
			$( $slides[ 0 ] ).show();
			$( $slides[ 0 ] ).find( '.answer' ).hide();
		}
		if ( hidden ) $this.hide();
	};

	//Listener for jump links to the left of the challenges browser
	var jumpSlide = function ( e ) {
		console.log( {
			'this': $this,
			'id': id,
			'container': $container,
			'slide': $slide
		} );
		e.preventDefault();

		var $this = $( this ),
			id = $this.data( 'id' ),
			$container = $this.parent().parent().parent(),
			$slide = $container.find( '.slide[data-id="' + id + '"]' );

		changeSlide( $container, id, $slide );
	};

	//Next question link click listener
	var nextSlide = function ( e ) {
		var $this = $( this ),
			$currentSlide = $this.parents( '.slide' ),
			currentId = $currentSlide.data( 'id' ),
			$container = $currentSlide.parent(),
			nextId = currentId + 1,
			$nextSlide = $container.find( '.slide[data-id="' + nextId + '"]' );

		e.preventDefault();

		if ( $nextSlide.length < 1 ) return;

		changeSlide( $container, nextId, $nextSlide );
	};

	//Previous question link click listener
	var previousSlide = function ( e ) {
		var $this = $( this ),
			$currentSlide = $this.parents( '.slide' ),
			currentId = $currentSlide.data( 'id' ),
			$container = $currentSlide.parent(),
			previousId = currentId - 1,
			$previousSlide = $container.find( '.slide[data-id="' + previousId + '"]' );

		e.preventDefault();

		if ( $previousSlide.length < 1 ) return;

		changeSlide( $container, previousId, $previousSlide );
	};

	//Clear out listeners and dynamic content and rebuild when window is resized
	var reInit = function ( e ) {
		$( '.challenge-data' ).each( function () {
			var $this = $( this ),
				$slideNav = $this.children( 'ul' ),
				$slides = $this.find( '.slide' ),
				hidden = true;
			$this.removeClass( 'browser' );
			$this.removeClass( 'mobile' );
			$slides.find( '> div > div' ).removeAttr( 'style' );
			if ( $this.css( 'display' ) != 'none' ) hidden = false;
			$this.removeAttr( 'style' );
			$slides.removeAttr( 'style' );
			$slides.children( 'div' ).removeAttr( 'style' );

			if ( hidden ) {
				$this.hide();
			}

			$slideNav.find( 'a[data-id]' ).off( 'click', jumpSlide );
			$this.find( '.previous' ).off( 'click', previousSlide );
			$this.find( '.next' ).off( 'click', nextSlide );
			$this.find( '.show-answer a' ).off( 'click', showAnswer );

			$this.find( 'nav' ).remove();
			$this.find( '.show-answer' ).remove();
			$slideNav.remove();
		} );
		$( '.challenge-data' ).each( initChallengeBrowser );
	};

	var showAnswer = function ( e ) {
		var $question = $( this ).parent().parent().parent(),
			$answer = $question.siblings();

		e.preventDefault();

		$answer.show();
		$question.hide();
		$question.parent().parent().children( 'ul' ).addClass( 'showing-answer' );
	};

	$( '.challenge-data' ).each( initChallengeBrowser );
	$( window ).on( 'resize', reInit );

} );
